import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const Security = () => {
  return (
    <div>
      <Navbar />
        <section className="in_page p70 bg4">
              <div className="container"> 
                  <div className="row align-items-center">
                  <div className="col-md-7">
                    <h1 className="hadding">Security Is Our Top Priority</h1> 
                    <p>At Dyntech, we build every system with defense-in-depth to protect your data and assets.</p> 
             </div>
                 <div className="col-md-4 col-lg-3 m-auto">
                    <img
                      src="/img/security.png"
                      alt="security"
                      className="img-fluid"
                    />
                  </div>
                    </div></div>
        
      </section>
         <section className="in_page p70 bg2">
              <div className="container"> 
                         <h3 className=" mb-3 "><b>Infrastructure & Compliance</b></h3>
       
            <ul className="list ">
                   <li><b>SOC 2 Type II Certified: </b> Rigorous audits of security controls.</li>                 
                  <li><b>ISO 27001 Aligned: </b> Information security management best practices.</li>                 
                  <li><b> Regular Penetration Tests: </b> Quarterly third-party testing and remediation. </li> 
                </ul>


               <h3 className=" mb-3 mt-4 mt-md-5"><b> Data Protection</b></h3>
                 <ul className="list ">
                  <li><b>Encryption at Rest:</b>  AES-256 on all databases and backups.</li>                 
                  <li><b> Encryption in Transit: </b>  TLS 1.2+ for all API and web traffic.</li>                 
                  <li><b> Key Management:  </b> Hardware Security Modules (HSMs) for encryption keys.</li>                 
                </ul>
                  <h3 className=" mb-2 mt-md-5  mb-3"><b> Access Controls</b></h3>
                 <ul className="list">
                  <li><b>  Multi-Factor Authentication (MFA):</b>  Mandatory for all user and admin accounts.</li>                 
                  <li><b>  Role-Based Permissions:</b>  Granular access policies by function and risk level.</li>                 
                  <li><b> Session Monitoring: </b>  Automated anomaly detection and forced logouts.</li>                 
                </ul>
               
                </div>
                </section>
                 <section className="in_page p70 bg4">
              <div className="container"> 
                   <h3 className=" mb-3"><b> Network & Infrastructure Security</b></h3>
                 <ul className="list ">
                  <li><b> DDoS Mitigation: </b>  Global scrubbing and rate limiting.</li>                 
                  <li><b>  Firewall & WAF: </b> Layered network defenses and application-level protections.</li>                 
                  <li><b> Redundancy & Failover: </b>  Multi-region deployment with automated failover.</li>                  
                </ul>
                  <h3 className=" mb-2 mt-md-5  mb-3"><b> Incident Response</b></h3>
                 <ul className="list ">
                  <li><b> 24/7 Security Operations Center: </b> Real-time monitoring and alerting. </li>                 
                  <li><b> Formal IR Playbooks:  </b> Established procedures for containment, eradication, and recovery.</li>                 
                  <li><b>  Post-Event Reviews:</b>  Root cause analysis and continuous improvement.</li>                  
                </ul>
                  <h3 className=" mb-2 mt-md-5 mb-3"><b> Security Resources:</b></h3>
                 <ul className="list ">
                  <li><b> Whitepaper:</b> Dyntech Security Architecture</li>                 
                  <li>Bug Bounty Program Details </li>                    
                </ul> 
                </div>
                </section>
      <Footer />
    </div>
  );
};

export default Security;
